import { h } from 'preact'
import { useState } from 'preact/hooks'

export default function Facet({ label, options, onSelect, onRemove }) {
	const [isOpen, setIsOpen] = useState(null)
	const toggle = () => setIsOpen(!isOpen)

	return (
		<div
			className={`facets__facet ${isOpen ? '--active' : ''}`}
			onClick={toggle}
			role="button"
			tabIndex={0}
		>
			<div className="facets__label">
				<span>{label}</span>

				<svg
					width="16"
					height="16"
					viewBox="0 0 48 48"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					style={{
						transition: 'transform .12s ease',
						transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
					}}
				>
					<path
						d="M8.36612 16.1161C7.87796 16.6043 7.87796 17.3957 8.36612 17.8839L23.1161 32.6339C23.6043 33.122 24.3957 33.122 24.8839 32.6339L39.6339 17.8839C40.122 17.3957 40.122 16.6043 39.6339 16.1161C39.1457 15.628 38.3543 15.628 37.8661 16.1161L24 29.9822L10.1339 16.1161C9.64573 15.628 8.85427 15.628 8.36612 16.1161Z"
						fill="#212121"
					/>
				</svg>
			</div>

			{isOpen && (
				<div className="facets__facet-options">
					{options.map(option => {
						const checked = option.selected
						const disabled = option.count == 0

						const onFacetChange = e => {
							e.stopPropagation()

							if (option.count == 0) {
								return
							}

							if (checked) {
								onRemove(option.name)
								return
							}

							onSelect(option.name)
						}

						return (
							<div
								className={`facets__facet-option ${option.count <= 0 ? 'disabled' : ''}`}
								key={`${option.name}-${option.url}`}
							>
								<div className="facets__facet-option__checkbox" onClick={onFacetChange}>
									<input
										type="checkbox"
										// onChange={}
										defaultChecked={checked}
										disabled={disabled}
									/>

									<span>{option.name}</span>
								</div>

								<span className="facets__facet-option__count">{option.count}</span>
							</div>
						)
					})}
				</div>
			)}
		</div>
	)
}
